module.exports = __webpack_public_path__ + "images/assets/1286b65660caf88cc2a1daa4264fa9ad.svg";